import { Individual } from '@aslanpay/portal-common-lib';

export type TabLabel =
  | 'profile'
  | 'payroll'
  | 'finance'
  | 'earnings'
  | 'reports'
  | 'points'
  | 'set-and-spend'
  | 'savings'
  | 'vouchers';

export interface TabsConfig {
  index: number;
  label: TabLabel;
  displayName: string;
  visible: boolean;
}

const getIndividualProfileTabs = (
  individual: Individual | undefined,
  isReserveEnabled: boolean,
  isSavingsEnabled: boolean
): TabsConfig[] => [
  { index: 0, label: 'profile', displayName: 'Profile', visible: true },
  { index: 1, label: 'payroll', displayName: 'Payroll', visible: !!individual?.payCalendarId },
  {
    index: 2,
    label: 'finance',
    displayName: 'Finance',
    visible: individual?.role === 'EMPLOYEE',
  },
  {
    index: 3,
    label: 'earnings',
    displayName: 'Earnings',
    visible: individual?.role === 'EMPLOYEE',
  },
  { index: 4, label: 'reports', displayName: 'Reports', visible: !!individual?.payCalendarId },
  {
    index: 5,
    label: 'points',
    displayName: 'Points',
    visible: individual?.role === 'EMPLOYEE',
  },
  {
    index: 6,
    label: 'set-and-spend',
    displayName: 'Set & Spend',
    visible: individual?.role === 'EMPLOYEE' && isReserveEnabled,
  },
  {
    index: 7,
    label: 'savings',
    displayName: 'Savings',
    visible: individual?.role === 'EMPLOYEE' && isSavingsEnabled,
  },
  {
    index: 8,
    label: 'vouchers',
    displayName: 'Vouchers',
    visible: individual?.role === 'EMPLOYEE',
  },
];

export default getIndividualProfileTabs;
